import React, { useEffect } from 'react';
import { t, Trans } from '@lingui/macro';
import PropTypes from 'prop-types';
import { Flex, Grid, H3, P, TextArea, Toggle } from '@decisiv/ui-components';
import SectionRow from '../../components/SectionRow';
import { FormGroup } from '../IntegrationDetailPage/StyledComponents';

export default function AutomaticRetry({
  handleForm,
  triggerTypeApplicationEvent,
  automaticRetryEnabled,
  showFields,
}) {
  const customEvent = (value, name) => ({ target: { value, name } });

  useEffect(() => {
    // eslint-disable-next-line
  }, [triggerTypeApplicationEvent]);

  return triggerTypeApplicationEvent ? (
    <SectionRow>
      <Grid.Column padding={0} span="3">
        <H3>
          <Trans>Automatic Retry</Trans>
        </H3>
      </Grid.Column>
      <Grid.Column padding={0}>
        <P shade={1} size="small" marginBottom={1}>
          <Trans>
            Enable automatic retry for application events invocations, the event
            gonna be retried after the set amount of time for a maximum of set
            retries
          </Trans>
        </P>
        <FormGroup key="automaticRetry">
          <Toggle
            name="automatic_retry_enabled"
            options={[
              {
                id: 'disabled',
                text: t`Disabled`,
              },
              { id: 'enabled', text: t`Enabled` },
            ]}
            onChange={(e) => {
              let convertedValue = false;
              convertedValue = e === 'enabled';
              handleForm({
                event: customEvent(convertedValue, 'automatic_retry_enabled'),
              });
            }}
            selected={automaticRetryEnabled ? 'enabled' : 'disabled'}
          />
          {showFields ? (
            <FormGroup>
              <TextArea
                label={t`Automatic Retry After in seconds(Max 900)`}
                name={t`retry_after`}
                required
                type="number"
                defaultValue={60}
                onChange={(e) => {
                  handleForm({ event: e });
                }}
                maxLength={3}
              />
              <Flex marginTop={1}>
                <TextArea
                  label={t`Max Retries`}
                  name={t`max_retries`}
                  required
                  type="number"
                  defaultValue={5}
                  onChange={(e) => {
                    handleForm({ event: e });
                  }}
                  maxLength={3}
                />
              </Flex>
            </FormGroup>
          ) : null}
        </FormGroup>
      </Grid.Column>
    </SectionRow>
  ) : (
    ''
  );
}

AutomaticRetry.propTypes = {
  handleForm: PropTypes.func.isRequired,
  triggerTypeApplicationEvent: PropTypes.bool.isRequired,
  automaticRetryEnabled: PropTypes.bool.isRequired,
  showFields: PropTypes.bool.isRequired,
};
